<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">Payment Terms</h6>
        </div>
    </b-row>

    <b-row class="my-2 ps-3">
        <b-col sm="12" md="12" lg="12">
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('Paymentterms.title') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common">20% upfront and 30 days Credit Period</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="2" sm="6" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('Paymentterms.creditperiod') }}</label>
                </b-col>
                <b-col lg="8" md="10" sm="6" cols="12" class="form-field-column">
                    <p class="details-black-field">30 Days</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="2" sm="6" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('Paymentterms.discount') }}</label>
                </b-col>
                <b-col lg="8" md="10" sm="6" cols="12" class="form-field-column">
                    <p class="details-black-field">Variable</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({

    setup() {
        return {

        }
    }

})
</script>

<style lang="scss"></style>